var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionsEditTheirEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3327 5.33333C10.3327 3.49239 8.84028 2 6.99935 2C5.1584 2 3.66602 3.49239 3.66602 5.33333C3.66602 7.17427 5.1584 8.66667 6.99935 8.66667C8.84028 8.66667 10.3327 7.17427 10.3327 5.33333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33398 13.3327C2.33398 10.7553 4.42332 8.66602 7.00065 8.66602C7.85065 8.66602 8.64758 8.89328 9.33398 9.29035",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4591 9.9566L13.0441 9.54153C12.7673 9.2648 12.3187 9.2648 12.0419 9.54153L9.8094 11.7741C9.51267 12.0708 9.3104 12.4488 9.22807 12.8603L9 14.0007L10.1403 13.7726C10.5519 13.6903 10.9299 13.488 11.2266 13.1913L13.4591 10.9587C13.7359 10.682 13.7359 10.2333 13.4591 9.9566Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsEditTheirEvents);
export default __webpack_public_path__ + "static/media/permissions_edit_their_events.ea70515dd369006ba7524b652eae14fe.svg";
export { ForwardRef as ReactComponent };